export const getAssetStatusClassName = (status?: string): string => {
  const normalized = status?.toLowerCase() ?? '';
  if (normalized === 'active' || normalized === 'enabled') {
    return 'status-active';
  }
  if (normalized === 'inactive') {
    return 'status-inactive';
  }
  if (normalized === 'disabled') {
    return 'status-disable';
  }
  return '';
};

export const getGatewayTwinStatusClassName = (status: string): string => {
  const normalized = status.toLowerCase();
  if (normalized === 'connected') {
    return 'status-active';
  }
  if (normalized === 'disconnected') {
    return 'status-inactive';
  }
  return '';
};

export const rowHasAlerts = (row: {
  alertsCount?: string | number;
  alerts?: unknown[];
}): boolean => {
  const alertsCount = parseInt(String(row.alertsCount), 10) || 0;
  const hasAlerts = Array.isArray(row.alerts) && row.alerts.length > 0;
  return hasAlerts || alertsCount > 0;
};
